import React, { useState } from "react";
import ChatScreen from "./ChatScreen";
import UserList from "./UserList";

const ChatPage = () => {
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | null>(
    null
  );
  const [isMobileView, setIsMobileView] = useState(false);

  const handleChatSelect = (customerId: string) => {
    setSelectedCustomerId(customerId);
    setIsMobileView(true);
  };

  const handleBackToList = () => {
    setIsMobileView(false);
    setSelectedCustomerId(null);
  };

  return (
    <div className="flex h-[calc(100vh-70px)] bg-gray-100 overflow-hidden">
      {/* Sidebar with UserList */}
      <div
        className={`w-full md:w-1/3 border-r border-gray-200 bg-white flex flex-col ${
          isMobileView ? "hidden md:flex" : "flex"
        }`}
      >
        <UserList
          onChatSelect={handleChatSelect}
          selectedCustomerId={selectedCustomerId}
        />
      </div>

      {/* Main chat area */}
      <div
        className={`flex-1 flex flex-col ${
          !isMobileView ? "hidden md:flex" : "flex"
        }`}
      >
        {selectedCustomerId ? (
          <ChatScreen
            customerId={selectedCustomerId}
            onBack={handleBackToList}
            showBackButton={isMobileView}
          />
        ) : (
          <div className="flex-1 flex items-center justify-center text-gray-500">
            <p>Select a chat to start messaging</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatPage;
